var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 166.91 125.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 62.87,
    x2: 166.91,
    y2: 62.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ecb365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37335"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M48.06,58.4L6.01,34.21m98.73,.55l-25.97,14.94m80.28,47.88v.14c-2.09-5.94-4.86-9.54-8.29-10.81,4.17-.93,7.36-2.77,9.58-5.53,2.22-2.76,3.32-6.26,3.32-10.54,0-5.79-2.09-10.1-6.29-12.94-4.19-2.84-10.62-4.25-19.29-4.25h-26.03V119.65h17v-26h2.54c3.39,0,5.89,.56,7.5,1.68,1.59,1.13,2.85,3.17,3.78,6.09l5.78,18.23h18.26l-7.86-22.07Zm-15.18-18c-1.91,1.39-4.78,2.07-8.61,2.07h-6.21v-17h4.38c4.61,0,7.98,.7,10.1,2.1,2.14,1.41,3.21,3.6,3.21,6.58,0,2.78-.96,4.86-2.87,6.25Zm-31.82-43.12v17.19h-17v38.14c0,5.22-.97,9.17-2.89,11.84-1.92,2.68-4.78,4.02-8.55,4.02s-6.37-1.25-8.05-3.73c-1.67-2.51-2.51-6.53-2.51-12.13V53.65h-.99l-15.01,8.62c-.62,.36-1,1.02-1,1.74v27.68c0,9.58,2.35,16.8,7.04,21.65,1.12,1.16,3.21,2.45,5.04,3.47,1.37,.76,1.39,2.71,.03,3.48l-7.16,4.12c-3.08,1.77-6.88,1.77-9.96-.01l-15.75-9.05c-.62-.36-1-1.02-1-1.74v-21c0-.72-.38-1.38-1-1.74l-9.97-5.73c-1.34-.76-3,.2-3,1.74v16.41c0,1.54-1.66,2.5-3,1.74l-12.3-7.08c-3.11-1.78-5.02-5.09-5.02-8.67V36.46c0-3.58,1.91-6.89,5.02-8.67L51.04,1.33c3.08-1.77,6.88-1.77,9.96,0l46.03,26.46c3.11,1.78,5.02,5.09,5.02,8.67Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFilled);
export default __webpack_public_path__ + "static/media/logo_filled.420b1ee9c76aa66dd97128d3bdc8bf9c.svg";
export { ForwardRef as ReactComponent };